export default "__VITE_PUBLIC_ASSET__672e487c__"